import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { WatchedSidePanelProps, useGetPath, WatchedEntry } from "src/common";
import { Breadcrumbs } from "../watch-list";

function ItemDetailsComponent(props: WatchedSidePanelProps) {
  const { current_account, entry, path_info, handleAction } = props;
  const [last_modification_date, setDate] = useState<string>(entry.last_modification_date);
  const { getPath, full_path_list } = useGetPath(current_account);

  useEffect(() => {
    (!!entry && !path_info) &&
      getPath(entry.collection_id, entry.id);
  }, [entry]);

  useEffect(() => {
    if (!!full_path_list && !last_modification_date) {
      const new_entry = new WatchedEntry(entry);
      new_entry.setFullPathList(full_path_list);
      (!entry.last_modification_date && !!new_entry.last_modification_date) && setDate(new_entry.last_modification_date);
    }
  }, [full_path_list]);

  return <Row className="metadata-list">
    <Col xs={12}>
      <label>Location</label>
      {
        (!!path_info || !!full_path_list) &&
        <Breadcrumbs
          current_account={current_account}
          entry={entry}
          path_info={path_info}
          full_path_list={full_path_list}
          handleAction={handleAction} />
      }
    </Col>
    <Col md={2} sm={12}>
      <label>Type</label>
      <b>{entry.type_label || entry.type}</b>
    </Col>
    {
      <Col md="auto" sm={12} className="ms-auto">
        <label>Modified</label>
        <b>{last_modification_date}</b>
      </Col>
    }
  </Row>;
}

export default React.memo(ItemDetailsComponent);
